export default "__VITE_ASSET__BSaFzM3P__"